import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function login(username, password) {
  const res = await axios.post(`${API_URL}/auth/login`, { username, password });
  return res.data;
}

export async function register(username, password, confirmPassword, email) {
  const res = await axios.post(`${API_URL}/auth/register`, { 
    username, 
    password, 
    confirmPassword, 
    email 
  });
  return res.data;
}

export async function lookupPhone(phone, token) {
  const res = await axios.post(
    `${API_URL}/lookup`,
    { phone },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function getProfile(token) {
  const res = await axios.get(
    `${API_URL}/profile`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function updateProfile(profileData, token) {
  const res = await axios.put(
    `${API_URL}/profile`,
    profileData,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function changePassword(passwordData, token) {
  const res = await axios.put(
    `${API_URL}/profile/password`,
    passwordData,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function deleteAccount(passwordData, token) {
  const res = await axios.delete(
    `${API_URL}/profile`,
    { 
      headers: { Authorization: `Bearer ${token}` },
      data: passwordData
    }
  );
  return res.data;
}

// Admin API functions
export async function getAllUsers(token) {
  const res = await axios.get(
    `${API_URL}/admin/users`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function getPendingUsers(token) {
  const res = await axios.get(
    `${API_URL}/admin/users/pending`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function getExpiringUsers(token, days = 30) {
  const res = await axios.get(
    `${API_URL}/admin/users/expiring?days=${days}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function getExpiredUsers(token) {
  const res = await axios.get(
    `${API_URL}/admin/users/expired`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function getUserDetails(userId, token) {
  const res = await axios.get(
    `${API_URL}/admin/users/${userId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function approveUser(userId, token) {
  const res = await axios.post(
    `${API_URL}/admin/users/${userId}/approve`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}

export async function revokeUser(userId, token) {
  const res = await axios.post(
    `${API_URL}/admin/users/${userId}/revoke`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
} 